import * as Yup from "yup";

export const BLOOD_GROUP_OPTIONS = [
  { value: "", label: "Select Blood Group" },
  { value: "A+", label: "A+" },
  { value: "A-", label: "A-" },
  { value: "B+", label: "B+" },
  { value: "B-", label: "B-" },
  { value: "O+", label: "O+" },
  { value: "O-", label: "O-" },
  { value: "AB+", label: "AB+" },
  { value: "AB-", label: "AB-" },
];

export const GENDER_OPTIONS = [
  { value: "", label: "Select Gender" },
  { value: "MALE", label: "Male" },
  { value: "FEMALE", label: "Female" },
];

export const YES_NO_OPTIONS = [
  { label: "Yes", value: "true" },
  { label: "No", value: "false" },
];

export const accountInfoSchema = Yup.object({
  resume_received_by: Yup.string().required("Resume received by is required"),
  interviewed_taken_by: Yup.string().required(
    "Interviewed taken by is required"
  ),
  qualification: Yup.string().required("Qualification is required"),

  total_experience_years: Yup.number()
    .typeError("Please enter a valid number")
    .min(0, "Years of experience cannot be negative")
    .required("Total experience in years is required"),

  is_fresher: Yup.string()
    .oneOf(["true", "false"], "Please select Yes or No")
    .required("Please specify if the candidate is a fresher"),

  appointment_letter_date: Yup.date().required(
    "Appointment letter date is required"
  ),

  to_be_joined_on: Yup.date().required("To be joined on is required"),

  company_policy_accepted_on: Yup.date().required(
    "Company policy accepted on is required"
  ),
});

export const documentsSections = [
  {
    title: "Previous Employer Documents",
    docs: [
      "Releaving Letter",
      "3 Month Salary Slip",
      "Experience Letter",
      "3 Month Bank Statement",
      "Offer Letter",
      "Increment Commitment Letter",
    ],
  },
  {
    title: "Documents Provided",
    docs: [
      "Resume",
      "Driving License",
      "Aadhar Card",
      "RC Copy of Vehicle",
      "PAN Card",
      "Insurance Copy",
      "Appointment Letter"
    ],
  },
];

export const DOCUMENTS_STATUS_LABELS = {
  APPROVED: "APPROVED",
  PENDING: "PENDING",
  MISSING: "MISSING",
  REJECTED: "REJECTED",
};

export const statusColors = {
  PENDING: "text-yellow-800 bg-yellow-100",
  APPROVED: "text-green-800 bg-green-100",
  MISSING: "text-orange-800 bg-orange-100",
  REJECTED: "text-red-800 bg-red-100",
};

// Map of document display name -> backend enum key
export const fileTypeKeys = {
  "Resume": "RESUME",
  "Aadhar Card": "AADHAR",
  "PAN Card": "PAN",
  "Driving License": "DRIVING_LICENSE",
  "RC Copy of Vehicle": "RC_COPY",
  "Insurance Copy": "INSURANCE_COPY",
  "Releaving Letter": "RELEAVING_LETTER",
  "Experience Letter": "EXPERIENCE_LETTER",
  "Offer Letter": "OFFER_LETTER",
  "Appointment Letter": "APPOINTMENT_LETTER",
  "3 Month Salary Slip": "SALARY_SLIP_3M",
  "3 Month Bank Statement": "BANK_STATEMENT_3M",
  "Increment Commitment Letter": "INCREMENT_LETTER",
};

export const DOCUMENTS_STATUS = [
  { label: "Pending", value: "PENDING" },
  { label: "Approve", value: "APPROVED" },
  { label: "Reject", value: "REJECTED" },
  { label: "Missing", value: "MISSING" },
]

export const FILE_TYPE_LABELS = {
  RESUME: "Resume",
  AADHAR: "Aadhar Card",
  PAN: "PAN Card",
  DRIVING_LICENSE: "Driving License",
  RC_COPY: "RC Copy of Vehicle",
  INSURANCE_COPY: "Insurance Copy",
  RELEAVING_LETTER: "Releaving Letter",
  EXPERIENCE_LETTER: "Experience Letter",
  OFFER_LETTER: "Offer Letter",
  APPOINTMENT_LETTER: "Appointment Letter",
  SALARY_SLIP_3M: "3 Month Salary Slip",
  BANK_STATEMENT_3M: "3 Month Bank Statement",
  INCREMENT_LETTER: "Increment Commitment Letter",
}

export const showDocumentsStar = (docName) => {
  if ([
    FILE_TYPE_LABELS.OFFER_LETTER,
    FILE_TYPE_LABELS.RESUME,
    FILE_TYPE_LABELS.AADHAR,
    FILE_TYPE_LABELS.PAN,
    FILE_TYPE_LABELS.APPOINTMENT_LETTER,
  ].includes(docName)) {
    return <span className="top-1 text-red-500">{"*"}</span>
  }

  return;
}

export const MANDATORY_DOCUMENTS = [
  "Resume",
  "Aadhar Card",
  "PAN Card",
  "Offer Letter",
  "Appointment Letter",
];
